import { SpamListEntry } from '@app/models'

export enum CheckStatus
{
  None = 'None',
  Pending = 'Pending',
  Spam = 'Spam',
  Pass = 'Pass',
  Error = 'Error'
}

export type SpamProvider = 'WhiteList' | 'BlackList' | 'CleanTalk' | 'OOPSpam' | 'SpamReportScoring' | 'AutomaticRules' | 'AIModel' | 'EntitySpamList';

export type SpamCheckEvent = {
  id: number
  status: string
  type: string
  creationDate: string
  updateDate: string
  result: {
    details: Record<SpamProvider, SpamCheckDetail[]>
    externalProvidersLogs: Record<SpamProvider, string[]>
  }
}

export enum SpamCheckMode {
  Detection = 'Detection',
  Prevention = 'Prevention'
}

export type SpamCheckDetail = {
  mode: SpamCheckMode
  status: CheckStatus
  reason: string
  spamlistEntryIds: number[]
  spamlistEntries: SpamListEntry[]
}

export type SpamChecksResponse = {
  events: SpamCheckEvent[]
}

export type MarkAsSpamReason = 'Spam' | 'Phishing' | 'IllegalContent'
